var utiltpm = {}

function isType(type) {
    return function(el) {
        return Object.prototype.toString.call(el) === '[object ' + type + ']'
    }
}
var isArray = isType('Array')
var isObject = isType('Object')
var isFunction = isType('Function')
var isString = isType('String')
var isNumber = isType('Number');

var isUndefined = function(obj) {
    return typeof obj === 'undefined'
}

function mergeDeep(target, ...sources) {
    if (!sources.length) return target
    const source = sources.shift()
    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) Object.assign(target, {
                    [key]: {}
                });
                mergeDeep(target[key], source[key]);
            } else {
                Object.assign(target, {
                    [key]: source[key]
                });
            }
        }
    }
    return mergeDeep(target, ...sources);
}
utiltpm = {
    isArray: isArray,
    isObject: isObject,
    isFunction: isFunction,
    isString: isString,
    isUndefined: isUndefined,
    isNumber: isNumber,
    merge: mergeDeep
}

function checkNumber(n, t) {
    n = n + "";
    n = n && n.replace(/\s+/g, "");
    var filter = t ? /^([1-9]\d*|0)?(\.(\d{1,2})?)?$/ : /^([1-9]\d*|0)?$/;
    return filter.test(n)
}
utiltpm.numberChange = function(val, num, fix2, int) {
    val = val + "";
    if (checkNumber(val, fix2)) {
        let hasDot = val.indexOf('.');
        if (num) {
            if (hasDot > -1) {
                let tpm = val.split(".");
                val = tpm[0].slice(0, num) + '.' + tpm[1].slice(0, fix2)
            } else if (val.length > num) {
                val = val.slice(0, num)
            }
        }
        if (int && hasDot > -1) {
            val = val.slice(0, hasDot);
        }
    } else {
        let tpm = val.split("");
        for (let i = 0; i < tpm.length; i++) {
            if (tpm[i] !== '.') {
                tpm[i] = tpm[i].replace(/\D/g, '');
            }

        }
        val = tpm.join("")
        if (val.indexOf('.') > -1) {
            let tpm1 = val.split(".");
            let tpm2 = tpm1[1].substring(0, 2)
            val = tpm1[0] + '.' + tpm2;
        }
    }
    return val
}
export var util = utiltpm


export var date = function(value, format) {
    if (value) {
        format = format || 'Y-M-D '
        if (value.length > 4 && value.indexOf("/") === -1 && value.indexOf("-") === -1) {
            value = Number(value)
        }
        if (!value) return ""
        var date = new Date(value);
        var Y = date.getFullYear();
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
        var D = date.getDate() < 10 ? ('0' + date.getDate()) : (date.getDate());
        var h = date.getHours() < 10 ? ('0' + date.getHours()) : (date.getHours());
        var m = date.getMinutes() < 10 ? ('0' + date.getMinutes()) : (date.getMinutes());
        var s = date.getSeconds() < 10 ? ('0' + date.getSeconds()) : date.getSeconds();
        var forma = format.split('');
        if (forma.length) {
            var dateVal = []
            forma.forEach(function(f) {
                switch (f) {
                    case "Y":
                        dateVal.push(Y);
                        break
                    case "M":
                        dateVal.push(M);
                        break
                    case "D":
                        dateVal.push(D);
                        break
                    case "h":
                        dateVal.push(h);
                        break
                    case "m":
                        dateVal.push(m);
                        break
                    case "s":
                        dateVal.push(s);
                        break
                    default:
                        dateVal.push(f)
                        break
                }
            })
            return dateVal.join('');
        }
        return '';
    } else {
        return '';
    }
}




export var REG = {
    "url": /^(http|https):\/\/(\w+.){2}(\w+)/,
    "mobile": /^((1)\d{10})$/,
    "number": /^0|([1-9][0-9]*)$/,
    "numberdot": /^([1-9]\d*|0)?(\.(\d{1,2})?)?$/,
    "email": /^([a-zA-Z0-9_\.\-])+\@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/
}


// WEBPACK FOOTER //
// ./src/utils/common.js